import * as API from '@/services/API';

export default {
  relateContact({ commit, dispatch, rootGetters }, payload) {
    return API.apiClient
      .post('/opportunities/' + rootGetters['opportunities/current_opportunity'].id + '/contacts', payload)
      .then((response) => {
        commit('SET_CURRENT_CONTACT', {});
        return dispatch('getContacts');
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  getContacts({ commit, rootGetters }, opportunityId) {
    if (!opportunityId) {
      opportunityId = rootGetters['opportunities/current_opportunity'].id;
    }
    API.apiClient
      .get('/opportunities/' + opportunityId + '/contacts')
      .then((response) => {
        commit('SET_CONTACT_LIST', response.data);
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  unlink({ commit, dispatch, rootGetters }, id) {
    return API.apiClient
      .delete('/opportunities/' + rootGetters['opportunities/current_opportunity'].id + '/contacts/' + id)
      .then((response) => {
        return dispatch('getContacts');
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
};
